import React, { Component } from 'react';
import { Link } from 'react-router-dom';

/*
  Этот компонент используется для оборачивания компонентов Materail UI
  для навигации.  Он должен быть написан как класс иначе будут ошибки
 */
export default class LinkWrapper extends Component {
  render() {
    return <Link {...this.props}/>
  }
}
